// Auth shim for the estimating module: the module reuses the HOST app's
// auth context wholesale (same user object: { name, email, role, ... }).

export { useAuth } from "@/context/AuthContext";

export function formatApiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (detail && typeof detail === "object" && detail.message) return detail.message;
  if (err?.message && !err?.response) return err.message;
  return fallback;
}
